/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
/* eslint react/prop-types: 0 */
import React from 'react';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import NxFontAwesomeIcon from '../../NxFontAwesomeIcon/NxFontAwesomeIcon';
var DetailLink = function DetailLink(_a) {
    var href = _a.href, children = _a.children;
    return (React.createElement("a", { href: href, target: "_blank", rel: "noreferrer", className: "nx-text-link" },
        React.createElement("span", null, children),
        React.createElement(NxFontAwesomeIcon, { icon: faExternalLinkAlt })));
};
export default DetailLink;
//# sourceMappingURL=DetailLink.js.map